export default {
	VersionFeatures: function(state) {
		return state.VersionFeatures;
	},

	TotalVersionFeature: function(state) {
		return state.Total;
	}
};
